// extracted by mini-css-extract-plugin
export default {"InvoiceSucessToast":"InvoiceSucessToast_InvoiceSucessToast__Pghhe","printButton":"InvoiceSucessToast_printButton__gNJ0A"};